module.exports = __webpack_public_path__ + "static/media/Transport-ship.66e1fcc8.svg";